import { render, staticRenderFns } from "./IconCoinPlus.vue?vue&type=template&id=42b6c0ad&scoped=true&"
import script from "./IconCoinPlus.vue?vue&type=script&lang=js&"
export * from "./IconCoinPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b6c0ad",
  null
  
)

export default component.exports